import { render, staticRenderFns } from "./SimpleTableContent.vue?vue&type=template&id=679b3898&scoped=true"
import script from "./SimpleTableContent.vue?vue&type=script&lang=js"
export * from "./SimpleTableContent.vue?vue&type=script&lang=js"
import style0 from "./SimpleTableContent.vue?vue&type=style&index=0&id=679b3898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679b3898",
  null
  
)

export default component.exports